import PropTypes from 'prop-types';
import React, { forwardRef, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

// material-ui
// --- THIS IS THE FIX ---
// We remove `makeStyles` and import the modern `useTheme` hook.
import { useTheme } from '@mui/material/styles';
import { Avatar, Chip, ListItemIcon, ListItemText, Typography, useMediaQuery } from '@mui/material';
import ListItemButton from '@mui/material/ListItemButton';

// project imports
import { setMenuOpen, setMenu, selectCustomization } from 'store/customization/customizationSlice';

// assets
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';

// The old useStyles hook is no longer needed.

const NavItem = ({ item, level }) => {
    // We no longer call the useStyles() hook.
    // const classes = useStyles();
    const theme = useTheme(); // This hook now correctly receives the global theme.
    const dispatch = useDispatch();
    const customization = useSelector(selectCustomization);
    // This useMediaQuery hook is now using the correct, modern theme object.
    const matchesSM = useMediaQuery(theme.breakpoints.down('md'));

    const Icon = item.icon;
    const itemIcon = item.icon ? (
        <Icon stroke={1.5} size='1.3rem' />
    ) : (
        <FiberManualRecordIcon
            sx={{
                // Styles from the old `listCustomIconSub` and `listCustomIconSubActive` classes.
                width: customization.isOpen.findIndex(id => id === item.id) > -1 ? '8px' : '6px',
                height: customization.isOpen.findIndex(id => id === item.id) > -1 ? '8px' : '6px',
            }}
            fontSize={level > 0 ? 'inherit' : 'default'}
        />
    );

    let itemTarget = item.target ? '_blank' : '';

    let listItemProps = item.external
        ? { component: 'a', href: item.url }
        : { component: forwardRef((props, ref) => <Link ref={ref} {...props} to={item.url} />) };

    const itemHandler = id => {
        dispatch(setMenuOpen(id));
        if (matchesSM) dispatch(setMenu(false));
    };

    // active menu item on page load
    useEffect(() => {
        const currentIndex = document.location.pathname
            .toString()
            .split('/')
            .findIndex(id => id === item.id);
        if (currentIndex > -1) {
            dispatch(setMenuOpen(item.id));
        }
    // eslint-disable-next-line
    }, [dispatch]);

    return (
        <ListItemButton
            {...listItemProps}
            disabled={item.disabled}
            // The styles from the old `listItem` and `listItemNoBack` classes are now here.
            sx={{
                borderRadius: `${customization.borderRadius}px`,
                marginBottom: '5px',
                alignItems: level > 1 ? 'flex-start' : 'center',
                backgroundColor: level > 1 ? 'transparent !important' : 'inherit',
                paddingTop: '8px',
                paddingBottom: '8px',
                paddingLeft: `${level * 23}px`
            }}
            selected={customization.isOpen.findIndex(id => id === item.id) > -1}
            onClick={() => itemHandler(item.id)}
            target={itemTarget}
        >
            <ListItemIcon sx={{ minWidth: '18px', marginTop: 'auto', marginBottom: 'auto' }}>
                {itemIcon}
            </ListItemIcon>
            <ListItemText
                primary={
                    <Typography
                        variant={customization.isOpen.findIndex(id => id === item.id) > -1 ? 'h5' : 'body1'}
                        color='inherit'>
                        {item.title}
                    </Typography>
                }
                secondary={
                    item.caption && (
                        <Typography
                            variant='caption'
                            // The style from the old `subMenuCaption` class is now here.
                            sx={{ ...theme.typography.subMenuCaption }}
                            display='block'
                            gutterBottom
                        >
                            {item.caption}
                        </Typography>
                    )
                }
            />
            {item.chip && (
                <Chip
                    color={item.chip.color}
                    variant={item.chip.variant}
                    size={item.chip.size}
                    label={item.chip.label}
                    avatar={item.chip.avatar && <Avatar>{item.chip.avatar}</Avatar>}
                />
            )}
        </ListItemButton>
    );
};

NavItem.propTypes = {
    item: PropTypes.object,
    level: PropTypes.number
};

export default NavItem;